import * as apiService from "../v2/apiService";
import * as endPoints from "../../constants/v2/endPoints";

export async function getAgentProfile(slug, isAgentId) {
  return await apiService.apiCall(
    endPoints.GET_AGENT_PROFILE + `?${isAgentId ? "id" : "slug"}=${slug}`,
    "GET",
    {},
  );
}
export async function getUserProfileForDM(id) {
  return await apiService.apiCall(
    endPoints.GET_USER_PROFILE_FOR_DM + `?id=${id}`,
    "GET",
    {},
  );
}

export async function getAgentIntroId(agentId) {
  return await apiService.apiCall(
    endPoints.GET_AGENT_INTRO_ID + `?id=${agentId}`,
    "GET",
    {},
  );
}
